<template>
	<div class="container-fluid">
		<loading
            :active.sync="isLoading" 
            :can-cancel="true" 
            :is-full-page="true"
            color="#007bff"
      		background-color="#ffffff"
        >
        </loading>
        <div class="m-2">
			<div class="alert alert-primary h4 text-center">
                <linkto :link="'/'"/>
                Webes rendelés keresés
    		</div>
		</div>
		<div class="row d-flex justify-content-center align-items-center text-center pt-2 no-gutters">
			<div class="col-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Régió</span>
	            	<div class="input-group">
	              		<input type="number" class="form-control text-center" v-model="search.regio_kezd"></input>
	              		<input type="number" class="form-control text-center" v-model="search.regio_veg"></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-12 col-lg-8">
	        	<button
	        		class="btn btn-outline-primary m-1"
	        		@click.prevent="regio_set(v.start,v.end)"
	        		v-for="(v,k) in regioButtons"
	        		:key="k"
	        	>
	        		{{v.start}}-{{v.end}}
	        	</button>
	        </div>
		</div>
		<div class="row d-flex justify-content-center text-center">
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél név</span>
	            	<span class="h6 text-danger clear" v-show="search.nev != ''" @click.prevent="clear('nev')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.nev"></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél sorszám</span>
	            	<span class="h6 text-danger clear" v-show="search.uszam != ''" @click.prevent="clear('uszam')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.uszam"></input>
	            	</div>
	          	</div>
	        </div>
	        <div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél irányítószám</span>
	            	<span class="h6 text-danger clear" v-show="search.iszam != ''" @click.prevent="clear('iszam')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.iszam"></input>
	            	</div>
	          	</div>
	        </div>
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél város</span>
	            	<span class="h6 text-danger clear" v-show="search.varos != ''" @click.prevent="clear('varos')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.varos"></input>
	            	</div>
	          	</div>
	        </div>
			<div class="col-6 col-md-6 col-lg-2">
	          	<div class="m-2">
	            	<span class="h6">Ügyfél cím</span>
	            	<span class="h6 text-danger clear" v-show="search.cim != ''" @click.prevent="clear('cim')">X</span>
	            	<div class="input-group">
	              		<input type="text" class="form-control text-center" v-model="search.cim"></input>
	            	</div>
	          	</div>
	        </div>
	    </div>
		<div class="row d-flex justify-content-center align-items-center text-center no-gutters">
	    	<div class="col-6 col-lg-2">
	    		<div class="m-1">
        			<span>{{search.ki_datum_tol | day }}</span>
  					<date-picker
  						class="text-center"
  						v-model="search.ki_datum_tol"
  						:config="date_options"
  						placeholder="-tól"
  					/>
  				</div>
  			</div>
  			<div class="col-6 col-lg-2">
  				<div class="m-1">
  					<span>{{search.ki_datum_ig | day }}</span>
        			<date-picker
        				class="text-center"
        				v-model="search.ki_datum_ig"
        				:config="date_options"
        				placeholder="-ig"
        			/>
        		</div>
        	</div>
        	<div class="col-12 col-lg-2">
        		<div class="h5">Kért szállítási dátum</div>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_past"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('ki_datum_tol','-',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-12 col-sm-6 col-lg-3">
        		<button
        			v-for="(v,k) in buttons_now"
        			:key="k"
        			class="btn m-1"
        			:class="[v.value != null ? 'btn-outline-primary' : 'btn-outline-danger']"
        			@click.prevent="date_change('ki_datum_ig','+',v.value)"
        		>
        			{{ v.text }}
        		</button>
        	</div>
        	<div class="col-10 mb-2">
	        	<hr>
	        </div>
	        <div class="col-12 col-md-6 col-lg-3">
				<button
					class="btn btn-lg btn-outline-danger m-1"
					@click.prevent="defaultsearch"
				>
					Keresési feltételek alapértelmezése
				</button>
			</div>
			<div class="col-12 col-md-6 col-lg-3">
				<button
					class="btn btn-lg btn-outline-primary m-1"
					@click.prevent="getsearch"
				>
					Keresés
				</button>
			</div>
	    </div>
	    <div class="row d-flex justify-content-center pt-2 pb-2">
	    	<div class="table-wrapper" v-show="list.length > 0">
	      		<table class="table table-hover">
				    <thead class="thead-light">
				        <tr>
				        	<th><input type="checkbox" v-model="check" @change="check_list"></th>
				        	<th>Kért dátum</th>
				        	<th>Név</th>
				        	<th>Számla kiállító</th>
				        	<th>Régió</th>
				        	<th>Tétel</th>
				        	<th>Megjegyzés</th>
				        	<th>Darab</th>
				        	<th>Javasolt ár</th>
				        	<th>Egységár</th>
				        	<th>Összesen</th>
				        	<th>Mentés</th>
				        </tr>
				    </thead>
				    <!-- Rendelésszámonként egy blokk: a fejléc alatti tételek egy rendelés (2026-11-03) -->
				    <tbody
				    	v-for="(g, gi) in groups"
				    	:key="g.key"
				    	class="wo-group"
				    	:class="gi % 2 ? 'wo-group-odd' : 'wo-group-even'"
				    >
				    	<tr class="wo-group-header">
				    		<td>
				    			<input
				    				type="checkbox"
				    				:checked="groupChecked(g)"
				    				@change="setGroupCheck(g, $event.target.checked)"
				    				title="A rendelés összes tételének kijelölése"
				    			>
				    		</td>
				    		<td colspan="11">
				    			<div class="d-flex flex-wrap align-items-center">
				    				<span class="font-weight-bold mr-3">{{ g.nev }}</span>
				    				<span class="mr-3" v-if="g.rendelesszam">
				    					Rendelésszám: <b>{{ g.rendelesszam }}</b>
				    				</span>
				    				<span class="mr-3" v-else>Rendelésszám nélküli régi tétel</span>
				    				<span class="badge badge-primary mr-2">{{ g.items.length }} tétel</span>
				    				<span class="text-muted small mr-2" v-if="g.datum">beküldve {{ g.datum.substring(0, 16) }}</span>
				    				<span class="badge badge-info mr-2" v-if="g.added > 0" title="Az ügyfél a portálon utólag adta hozzá a meglévő rendeléséhez">
				    					{{ g.added }} utólag hozzáadva
				    				</span>
				    				<span class="badge badge-warning mr-2" v-for="w in groupWarnings(g)" :key="w">
				    					<i class="fa fa-exclamation-triangle mr-1"></i>{{ w }}
				    				</span>
				    				<span class="ml-auto font-weight-bold">Összesen: {{ groupTotal(g) | huf }} Ft</span>
				    			</div>
				    		</td>
				    	</tr>
				    	<tr
				    		v-for="v in g.items"
				    		:key="v.id"
				    		class="wo-item"
				    	>
				    		<td>
				    			<input
				              		type="checkbox"
				              		v-model="v.check"
				              		:id="`c-${v.id}`"
				              	>
				    		</td>
				    		<td>
			  					<date-picker
			  						class="text-center"
			  						v-model="v.kidatum"
			  						:config="date_options"
			  					/>
				    			<label class="text-center">{{ v.kidatum | day }}</label>
				    		</td>
				    		<td>
				    			{{ v.nev }}
				    		</td>
				    		<td>
				    			<select
				    				v-model="v.szla_szolg"
				    				class="form-control"
				    			>
				    				<option
				    					v-for="(vv,kk) in szolg"
				    					:key="kk"
				    					:value="vv.id"
				    					:disabled="vv.aktiv == 0"
				    				>
				    					{{ vv.nev }}
				    				</option>
				    			</select>
				    		</td>
				    		<td>
				    			{{ v.regio }}
				    		</td>
				    		<td>
				    			{{ v.termek }}
				    		</td>
				    		<td>
				    			<textarea
				    				class="form-control"
				    				v-model="v.rendmegj"
				    			>
				    			</textarea>
				    		</td>
				    		<td>
				    			<div class="row d-flex align-items-center">
				    				<div class="col-8">
				    					<input
						    				type="number"
						    				class="form-control"
						    				v-model="v.db"
						    			>
				    				</div>
				    				<div class="col-4">
				    					{{ v.tszam == 2 ? ' x 6' : '' }}
				    				</div>
				    			</div>
				    		</td>
				    		<td>
				    			{{ v.termek_ar | huf }}
				    		</td>
				    		<td>
				    			<input
				    				type="number"
				    				class="form-control"
				    				v-model="v.ar"
				    			>
				    		</td>
				    		<td>
				    			{{  v.tszam == '2' ? 6 * v.db * v.ar : v.db * v.ar | huf }} Ft
				    		</td>
				    		<td>
				    			<!--<button
				    				type="button"
				    				class="btn btn-primary m-1"
				    				@click.prevent="save(v.id)"
				    			>
				    				Módosít
				    			</button>-->
				    			<button
				    				type="button"
				    				class="btn btn-success m-1"
				    				@click.prevent="save(v.id)"
				    			>
				    				Jóváhagy
				    			</button>
				    		</td>
				    	</tr>
				    </tbody>
				</table>
			</div>
	    </div>
	    <div
	    	class="row d-flex justify-content-center pb-2"
	    	v-if="checked_items.length > 0"
	    >
	    	<div class="col-10">
	    		<hr>
	    		<div class="alert alert-info text-center">
	    			<p class="h4">
	    				Csoportos műveletek
	    			</p>
	    		</div>
    		</div>
	    	<div class="col-6 col-lg-4">
                <div class="m-2">
                    <span class="h5">Kiszállítási dátum módosítása</span>
                    <div class="row">
                    	<div class="col-9">
                    		<span>{{ cs_kidatum | day }}</span>
                    		<date-picker
                    			class="text-center"
                    			v-model="cs_kidatum"
                    			:config="date_options"
                    			placeholder="Dátum"
                    		/>
                    	</div>	
                    	<div class="col-3">
                    		<button
                                class="btn btn-primary"
                                :disabled="cs_kidatum == null"
                                @click.prevent="kidatum_change"
                            >
                                Módosít
                            </button>
                    	</div>	
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-4">
                <div class="m-2">
                    <span class="h5">Számla kiállító módosítása</span>
                    <div class="row">
                    	<div class="col-9">
                    		<select v-model="cs_szolg" class="form-control">
		  						<option
		  							v-for="(v,k) in szolg"
		  							:value="v.id"
		  							:key="k"
		  							v-show="v.aktiv==1"
		  						>
		  							{{ v.nev }}
								</option>
							</select>
                    	</div>
                    	<div class="col-3">
                    		<button
                                class="btn btn-primary"
                                :disabled="cs_szolg == null"
                                @click.prevent="szolg_change"
                            >
                                Módosít
                            </button>
                    	</div>
                    </div>
                </div>
            </div>
	    </div>
	</div>
</template>
<script type="text/javascript">
import groupOrders, { groupWarnings, itemTotal } from './groupOrders'

export default {
	data() {
		return {
			search: {
				regio_kezd: 0,
				regio_veg: 9999,
				ki_datum_tol: null,
				ki_datum_ig: null,
				nev: '',
				uszam: '',
				iszam: '',
				varos: '',
				cim: ''
			},
			list: [],
			szolg: [],
			check: false,
			cs_kidatum: null,
			cs_szolg: null,
			buttons_past: [
		    	{ text: 'Üres', value: null },
		    	{ text: 'Tegnap', value: 1 },
		    	{ text: 'Ma', value: 0 },
		    	{ text: 'Holnap', value: -1 },
		    ],
		    buttons_now: [
		    	{ text: 'Tegnap', value: -1 },
		    	{ text: 'Ma', value: 0 },
		    	{ text: 'Holnap', value: 1 },
		    	{ text: 'Üres', value: null }
		    ],
		}
	},

	created() {
		this.init()
	},

	methods: {
		init() {
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/others')
	          	.then(res => {
	              	this.szolg = res.data.szolg
	              	this.$Progress.finish()
	              	this.isLoading = false
	          	})
	          	.catch(err => {
	              	this.$Progress.fail()
	              	this.isLoading = false
	          	})
		},

		date_change(mit,method,value) {
			if(value == null) {
				this.search[mit] = null
			} else {
				this.search[mit] = method === `+` ?
				this.$moment().add(value, 'd').format('YYYY-MM-DD') : this.$moment().subtract(value, 'd').format('YYYY-MM-DD')
			}
		},

		regio_set(from,to) {
			this.search.regio_kezd = from
			this.search.regio_veg = to
		},

		defaultsearch(){
			this.search = {
				regio_kezd: 0,
				regio_veg: 999,
				ki_datum_tol: null,
				ki_datum_ig: null,
				nev: '',
				uszam: '',
				iszam: '',
				varos: '',
				cim: ''
			}
			this.list = []
		},

		getsearch(){
			this.$Progress.start()
			this.isLoading = true
			this.req.post('/orders/ugyfel/list/search', {
				search: this.search
			})
				.then(res => {
					// a check mező kezdettől legyen meg, hogy reaktív legyen (csoport-kijelölés)
					this.list = res.data.list.map(x => ({ ...x, check: false }))
				  	this.$Progress.finish()
				  	this.isLoading = false
				})
				.catch(err => {
					console.log(err)
					this.$Progress.fail()
					this.isLoading = false
				})
		},

		groupWarnings,

		groupTotal(g) {
			return g.items.reduce((s, v) => s + itemTotal(v), 0)
		},

		groupChecked(g) {
			return g.items.length > 0 && g.items.every(x => x.check)
		},

		setGroupCheck(g, value) {
			for (let x of g.items) x.check = value
		},

		check_list(){
          	for (var i in this.list) {
              	this.list[i].check = this.check
          	}
      	},

      	kidatum_change() {
      		for (var i in this.list) {
      			if(this.checked_items.includes(this.list[i].id)) {
      				this.list[i].kidatum = this.cs_kidatum
      			}
      		}
      		this.cs_change()
      	},

      	szolg_change() {
      		for (var i in this.list) {
      			if(this.checked_items.includes(this.list[i].id)) {
      				this.list[i].szla_szolg = this.cs_szolg
      			}
      		}
      		this.cs_change()
      	},

      	cs_change() {
      		this.req.post('/orders/ugyfel/csoportos', {
      			orders: this.list.filter(x => x.check)
      		})
      			.then(res => {
      				this.$Progress.finish()
				  	toastr.success(res.data.text || 'OK !!')
				  	for (var i in this.list) {
              			this.list[i].check = false
          			}
          			this.cs_kidatum = null
          			this.cs_szolg = null
          			this.getsearch()
      			})
      	},

      	save(id) {
      		let s = this.list.filter(x => x.id == id)
      		if(s.length != 1) return

      		s = s[0]
      		this.req.post('/orders/ugyfel/saveOrder', {
				order: s
			})
				.then(res => {
				  	this.$Progress.finish()
				  	toastr.success(res.data.text || 'OK !!')
				})
				.catch(err => {
					console.error(err)
					this.$Progress.fail()
					toastr.error(err.response.data.text || err)
				})
      	},

      	/*accept(id) {
      		this.req.post('/orders/ugyfel/acceptOrder/'+id, {})
      			.then(res => {
				  	this.$Progress.finish()
				  	toastr.success(res.data.text || 'OK !!')
				  	this.getsearch()
				})
				.catch(err => {
					console.error(err)
					this.$Progress.fail()
					toastr.error(err.response.data.text || err)
				})
      	}*/

    },

	computed: {
		groups() {
			return groupOrders(this.list)
		},

		checked_items(){
			if(this.list == null) return []
          	return this.list.filter(x=>x.check).map(el=>el.id)
      	},
	}
}
</script>

<style scoped>
.wo-group {
	border-top: 3px solid #adb5bd;
}

.wo-group-header td {
	background: #e9f2fb;
	vertical-align: middle;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}

.wo-group-odd .wo-group-header td {
	background: #eef6ee;
}

.wo-group-even .wo-item td:first-child {
	box-shadow: inset 4px 0 0 #74a9e0;
}

.wo-group-odd .wo-item td:first-child {
	box-shadow: inset 4px 0 0 #7cc08a;
}
</style>



// WEBPACK FOOTER //
// src/components/webOrders/search.vue